import { useOutletContext } from 'react-router-dom';

export function useSalesEmbedded(propEmbedded = false) {
  const outlet = useOutletContext();
  return Boolean(propEmbedded || outlet?.embedded);
}
